import { ReactElement, useCallback, useState } from 'react';

import { Link, Modal, ModalMaxHeight, ModalWidth, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { AdamedExpertRegisterModalContent } from './AdamedExpertRegisterModalContent';
import { AdamedExpertAuthenticateModalContent } from './AdamedExpertAuthenticateModalContent';
import { AdamedExpertModalLogo } from './AdamedExpertModalLogo';
import { translationKeys } from './translations';

type AdamedExpertModalProps = {
   onClose: VoidFunction;
   authenticateOrRedirect: VoidFunction;
};

type Content = 'AUTHENTICATE' | 'REGISTER';

export const AdamedExpertModal = (props: AdamedExpertModalProps): ReactElement => {
   const [content, setContent] = useState<Content>('AUTHENTICATE');
   const toggleContent = useCallback(() => {
      if (content === 'AUTHENTICATE') {
         setContent('REGISTER');
         return;
      }
      setContent('AUTHENTICATE');
   }, [setContent, content]);
   return (
      <Modal
         title={<AdamedExpertModalLogo />}
         testId={'adamedExpert'}
         width={ModalWidth.NORMAL}
         height={ModalMaxHeight.FULL}
      >
         <StyledFlex direction={'column'} gap={24}>
            <Translate>{translationKeys.modal.info[content]}</Translate>
            {content === 'AUTHENTICATE' ? (
               <AdamedExpertAuthenticateModalContent onClose={props.onClose} />
            ) : (
               <AdamedExpertRegisterModalContent
                  onClose={props.onClose}
                  authenticateOrRedirect={props.authenticateOrRedirect}
               />
            )}
            <StyledFlex gap={4}>
               <Translate>{translationKeys.modal.navigate[content].info}</Translate>
               <Link
                  testId={'contentToggle'}
                  label={translationKeys.modal.navigate[content].link}
                  onClick={toggleContent}
               />
            </StyledFlex>
         </StyledFlex>
      </Modal>
   );
};
